import { render, staticRenderFns } from "./studentsByModality.vue?vue&type=template&id=26283fb4&scoped=true&"
import script from "./studentsByModality.js?vue&type=script&lang=js&"
export * from "./studentsByModality.js?vue&type=script&lang=js&"
import style0 from "./studentsByModality.scss?vue&type=style&index=0&id=26283fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26283fb4",
  null
  
)

export default component.exports